import React from 'react';
import {connect} from 'react-redux';
import strings from '../../utils/strings';

import AudioPlayer from '../../components/AudioPlayer';
import audiode from '../../assets/sounds/adult/de/sprakforslesaSounds/Introduksjon-sprakforstaelse.mp3';

class Intro extends React.Component {
	constructor(props) {
		super(props);
		this.audio = audiode;
	}

	render() {
		const {onNextStep} = this.props;

		return (
			<div>
				<div className="text-left">
				<p>
					<AudioPlayer
						onErrorPlay={() => {
							console.log('Something went wrong');
						}}
						autoplay
						inline
						src={this.audio}
					/>
					{strings.sprakforstaelseIntro}
				</p>
				<p>{strings.letsStartwith2Trials}</p>
				<p>{strings.testStartGeneral}</p>
				</div>
				<button
					className="lit-btn bg-primary"
					onClick={() => {
						onNextStep();
					}}
				>
					{strings.toPractice}
				</button>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
